// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-unauthorized-access {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.container-unauthorized-access .fa {\n    color: #00AEEF;\n    font-size: 100px;\n}\n\n.container-unauthorized-access button {\n    margin: 15px auto;\n}", ""]);
// Exports
module.exports = exports;
